import React, { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { Form, InputGroup } from 'react-bootstrap';

interface Props {
  page: number,
  size: number,
  setPage: Dispatch<SetStateAction<number>>,
  setSize: Dispatch<SetStateAction<number>>,
}

const sizes = [9, 12, 18, 24, 36];

const PageSizeSelector = (props: Props) => {

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    props.setSize(parseInt(event.currentTarget.value));
  }

  return(
    <InputGroup size="sm">
      <Form.Control as="select" defaultValue={props.size} onChange={handleChange} aria-label="Aantal producten per pagina" aria-describedby="per-page">
        {sizes.map((s, i) => <option key={i} value={s}>{s}</option>)}
      </Form.Control>
      <InputGroup.Append>
        <InputGroup.Text id="per-page">per pagina</InputGroup.Text>
      </InputGroup.Append>
    </InputGroup>
  );
}

export default PageSizeSelector;